<template>
  <v-container
    pa-0
    class="home">
    <!-- META-DATA -->
    <vue-headful
      :title="this.$store.state.app.meta.title + this.$store.state.app.meta.titleSuffix"
      :description="this.$store.state.app.meta.description" />

    <hero />

    <!-- NEW MARKETING -->

    <div class="landing-wrapper">
      <div class="landing-banner">
        <h3>The MemerHat</h3>
      </div>

      <div class="landing-panel">
        <v-img
          :src="require('@/assets/images/landing-page/panel-1.jpg')"
          contain
          class="landing-panel__image" />
        <p class="landing-panel__content">
          The MemerHat features a 2"x4" hook-and-loop panel on the front, which lets you attach and remove any MemerHats patch at any time - and it comes in many styles.
          <br>
          <v-btn
            class="landing-panel__cta-button"
            :to="{ name: 'hat-catalog'}"
            large
            outline
            color="black">
            shop hats
          </v-btn>
        </p>
      </div>

      <div class="landing-panel landing-panel--align-left">
        <v-img
          :src="require('@/assets/images/landing-page/panel-2.jpg')"
          contain
          class="landing-panel__image" />
        <p class="landing-panel__content landing-panel__content--align-left">
          Our printed vinyl patches are interchangeable, and our collection of designs is always growing.
          <br>
          <v-btn
            class="landing-panel__cta-button"
            :to="{ name: 'patch-catalog'}"
            large
            outline
            color="black">
            browse patch collection
          </v-btn>
        </p>
      </div>

      <div class="landing-panel">
        <v-img
          :src="require('@/assets/images/landing-page/panel-3.jpg')"
          contain
          class="landing-panel__image" />
        <p class="landing-panel__content">
          You can use our <router-link :to="{ name: 'custom-start'}">custom patch creation tool</router-link> to easily create a unique patch out of any image - even photos!
          <br>
          Better yet: our custom patches have the same low price and fast shipping as all our other patches!
          <br>
          <v-btn
            class="landing-panel__cta-button"
            :to="{ name: 'custom-start'}"
            large
            outline
            color="black">
            create your own
          </v-btn>
        </p>
      </div>
    </div>

    <featured-patches />


    <latest-news />
  </v-container>
</template>

<script>
import Hero from '../components/home/Hero.vue';
import FeaturedPatches from '../components/home/FeaturedPatches.vue';
import LatestNews from '../components/home/LatestNews.vue';

export default {
  name: 'Home',
  components: {
    Hero,
    FeaturedPatches,
    LatestNews,
  },
};
</script>

<style lang="stylus" scoped>
@require('../stylus/base')

.landing-wrapper
  padding: $base-padding*4

.landing-banner
  display: flex
  flex-flow: row wrap
  align-items: center
  justify-content: center

.landing-panel
  display: flex
  flex-flow: row wrap
  align-items: center
  justify-content: center;
  &--align-left
    flex-direction: row-reverse;
  &__image,
  &__content
    flex: 0 1 24rem
    max-height: 20rem
    padding: $base-padding*4
    text-align: right
    &--align-left
      text-align: left
    @media screen and (max-width: 48rem)
      flex-basis: 100%
      text-align: center
  &__cta-button
    margin-top: $base-padding*4
    margin-right: 0
    margin-left: 0

</style>
